export default "__VITE_ASSET__CKoDZrT___"